import { FC, useEffect } from 'react';

import { getSelectedLandingPageTemplates, getSelectedNamedLandingPageTemplates } from '@features/landingPageTemplatesSlice';
import useTranslateLandingPageTemplates from '@hooks/useTranslateLandingPageTemplates';
import NewOrderBase from '@routes/NewOrder/NewOrderBase';
import { ROUTES } from '@routes/constants';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const NewOrderLandingPageTemplates: FC = () => {
  const selectedLandingPageTemplates = useSelector(getSelectedLandingPageTemplates);
  const { mutateAsync, isLoading, error, isError, reset } = useTranslateLandingPageTemplates();
  const navigate = useNavigate();

  const namedSelected = useSelector(getSelectedNamedLandingPageTemplates);

  useEffect(() => {
    if (!selectedLandingPageTemplates || !selectedLandingPageTemplates.length) navigate(ROUTES.EMAILS);
  }, [selectedLandingPageTemplates, navigate]);

  return (
    <NewOrderBase
      type={'landing page templates'}
      mutationError={error}
      mutationIsError={isError}
      mutationIsLoading={isLoading}
      mutationReset={reset}
      selected={selectedLandingPageTemplates}
      onSend={(data) => mutateAsync({ ...data, ids: selectedLandingPageTemplates })}
      namedSelected={namedSelected}
    />
  );
};

export default NewOrderLandingPageTemplates;
